<template>
  <div class="box">
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
    <div class="box-body">
      <div class="text-right" v-if="$route.name === 'upActivity' && (activity.status === 0 || activity.status === 1)">
        <button class="btn btn-danger" data-toggle="modal" data-target="#delModal"><i class="fa fa-trash"></i></button>
      </div>
      <ul class="nav nav-tabs" style="margin-bottom: 10px;">
        <li role="presentation" :class="{'active': cMethod == 1}" @click="checkActivity(true, 1)">
          <a>活動資訊</a>
        </li>
        <li role="presentation" :class="{'active': cMethod == 2}" @click="checkActivity(true, 2)">
          <a>贈送規則</a>
        </li>
        <li role="presentation" :class="{'active': cMethod == 3}" @click="checkActivity(true, 3)">
          <a>折抵規則</a>
        </li>
        <li role="presentation" :class="{'active': cMethod == 4}" @click="checkActivity(true, 4)">
          <a>優惠券</a>
        </li>
      </ul>
    </div>
    <div class="box-body">
      <div class="row m-b-15 center-block" v-show="cMethod === 1">
        <div class="col-xs-12">
          <br />
          <div class="box-body form-left">
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>活動名稱(前台)</span>
                <input class="form-control" placeholder="" type="text" v-model="activity.title" maxlength="45">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>活動名稱(後台)</span>
                <input class="form-control" placeholder="" type="text" v-model="activity.name" maxlength="45">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>活動順序</span>
                <input class="form-control" placeholder="" type="text" v-model="activity.sort" maxlength="2">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>活動說明(前台)</span>
                <textarea class="form-control" placeholder="活動說明" v-model="activity.content" maxlength="256"></textarea>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">活動說明(後台)</span>
                <textarea class="form-control" placeholder="活動說明" v-model="activity.description" maxlength="256"></textarea>
              </div>
              <br />
            </div>
          </div>
          <div class="box-body form-right">
            <div v-if="getRoleType === 99">
              <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>擁有者
                  </span>
                <div>
                  <multiselect
                          v-model="activity.owner_type"
                          :options="ownerTypeOptions"
                          :searchable="true"
                          :allow-empty="false"
                          :close-on-select="true"
                          placeholder="擁有者"
                          :show-labels="false"
                          :multiple="false"
                          label="label"
                          track-by="label"
                  >
                  </multiselect>
                </div>
              </div>
              <br>
            </div>
            <div v-show="getRoleType === 99 || (getRoleType === 30 && !info.info.activity_id)">
              <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>參與品牌
                  </span>
                <div v-if="activity.owner_type.value === 1">
                  <multiselect
                          v-model="brandSelectMuti"
                          :options="brandBrief"
                          label="label"
                          track-by="label"
                          :searchable="false"
                          :allow-empty="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          placeholder="品牌"
                          :show-labels="false"
                          :multiple="true"
                          @input="getMutiStore"
                  >
                  </multiselect>
                </div>
                <div v-else>
                  <multiselect
                          v-model="brandSelect"
                          :options="brandBrief"
                          :searchable="true"
                          :allow-empty="false"
                          :close-on-select="true"
                          placeholder="品牌"
                          :show-labels="false"
                          :multiple="false"
                          label="label"
                          track-by="label"
                          @input="getStore"
                  >
                  </multiselect>
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group cr-schedule">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>活動開始時間
                  </span>
                <date-time-picker :date="activity.aTime.start" :option="timeoption" :limit="startLimit"></date-time-picker>
                <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.start">-->
              </div>
              <br />
            </div>
            <div>
              <div class="input-group cr-schedule">
                        <span class="input-group-addon">
                          <span class="text-red">＊ </span>活動結束時間
                        </span>
                <date-time-picker :date="activity.aTime.end" :option="timeoption" :limit="endLimit"></date-time-picker>
                <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.end">-->
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">活動備註</span>
                <textarea class="form-control" placeholder="活動說明" v-model="activity.remark"></textarea>
              </div>
              <br />
            </div>
          </div>
          <div class="col-xs-12 p-sm-10-p m-x-10 form-left" v-if="getRoleType !== 10">
            <h5><span class="text-red">＊ </span>參與店家</h5>
            <!-- 參與店家 -->
            <muti-select-two :setting="addStoresSetting" :reNew="reNew" :reSet="reSet"></muti-select-two>
            <!--{{addStoresSetting.choose}}-->
          </div>
        </div>
      </div>
      <div class="row m-b-15 center-block" v-show="cMethod === 2">
        <div class="col-xs-12">
          <activity-strategy :activity="activity" :info="info" :brandList="brandList" :addStoresSetting="addStoresSetting"
                             :storeList="aStoreList" :aStoreOption="aStoreOption" :setInfoTimes="setInfoTimes">
          </activity-strategy>
        </div>
      </div>
      <div class="row m-b-15 center-block" v-show="cMethod === 3">
        <div class="col-xs-12">
          <coupon-strategy :giveCoupons="giveCoupons" :info="info" :brandList="brandList" :addStoresSetting="addStoresSetting"
                           :storeList="aStoreList" :aStoreOption="aStoreOption" :setInfoTimes="setInfoTimes">
          </coupon-strategy>
        </div>
      </div>
      <div class="row m-b-15 center-block" v-show="cMethod === 4">
        <div class="col-xs-12">
          <coupon-list :giveCoupons="giveCoupons" :info="info" :brandList="brandList" :storeList="aStoreList" :activity="activity"
                       :setInfoTimes="setInfoTimes">
          </coupon-list>
        </div>
      </div>
      <div class="box-footer text-center">ˋ
        <button class="btn btn-fail" @click="$router.go(-1)" v-if="cMethod === 1">
          取消
        </button>
        <button class="btn btn-success" @click="cMethod--" v-else>
          上一步
        </button>
        <button class="btn btn-success" @click="checkActivity(false, 0)" v-if="cMethod === 4 && $route.name === 'crActivityInfoForm'">
          新增
        </button>
        <button class="btn btn-success" @click="checkActivity(false, 0)" v-else-if="cMethod === 4 && $route.name === 'upActivity'">
          更新
        </button>
        <button class="btn btn-success" @click="checkActivity(false, 0)" v-else>
          下一步
        </button>
      </div>
      <div v-for="(cInfo, index) in couponList">
        <div class="modal fade" :id="'couponRegisterModal' + index" role="dialog">
          <div class="modal-dialog choose-modal">
            <div class="modal-content pull-left">
              <div class="modal-header pull-left w-100-p">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <h4 class="modal-title text-left">優惠券設定</h4>
              </div>
              <div style="width: calc(100% - 80px)" class="card m-y-1 pull-left m-y-10 c-pointer" @click="clickCoupon()"
                   :data-target="'#couponRegisterModal' + index" data-toggle="modal" v-if="coupon.coupon_info"
              >
                <div class="coupon-left p-10">
                  <h4><span v-if="coupon.coupon_info.name">{{coupon.coupon_info.name}}</span><span v-else>優惠券名稱</span></h4>
                  <h5><span v-if="coupon.coupon_info.description">{{coupon.coupon_info.description}}</span><span v-else>優惠券描述....</span></h5>
                  <h5>到期：<span v-if="coupon.time_config.start_time.time">{{coupon.time_config.start_time.time}} ~ {{coupon.time_config.end_time.time}}</span><span v-else>{{nowTime}} ~ {{nowTime}}</span></h5>
                </div>
                <div class="coupon-right p-10">
                  <div class="v-middle">
                    $<span v-if="coupon.coupon_info.discount_value">{{coupon.coupon_info.discount_value}}</span><span v-else>10</span>
                  </div>
                </div>
              </div>
              <!--
              <div class="coupon-edit-block pull-left">
                <button v-if="couponList.length > 1" class="btn btn-danger" @click="couponList.splice(index, 1)"><i class="fa fa-trash"></i></button>
                <br v-if="couponList.length > 1">
                <button class="btn btn-default m-t-5"><i class="fa fa-pencil"></i></button>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import couponList from './CouponList.vue'
import couponStrategy from './CouponStrategy.vue'
import activityStrategy from './ActivityStrategy.vue'
export default {
  props: {
    info: Object
  },
  components: {
    'date-time-picker': datetimePicker,
    'coupon-list': couponList,
    'coupon-strategy': couponStrategy,
    'activity-strategy': activityStrategy
  },
  data () {
    return {
      delOption: {
        id: 'delModal',
        title: '刪除活動',
        body: '確定刪除活動?<br>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delActivity'
          }
        ]
      },
      cMethod: 1,
      activityMethod: 1,
      // modal test
      orderType: [
        {label: '一般單', value: 1},
        {label: '團購單 - 團長', value: 2},
        {label: '團購單 - 團員', value: 3}
      ],
      orderMethod: [
        {label: '當日單', value: 1},
        {label: '預訂單', value: 2}
      ],
      deliveryType: [
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      coupon: {
        type: {label: '固定起迄時間', value: 1},
        price_type: {label: '免稅', value: 1},
        discount_type: {label: '折扣金額', value: 1},
        setting: {label: '依訂單購買商品數設定', value: 1},
        useType: {label: '品牌型', value: 2}
      },
      otherCoupon: [],
      // end
      otherCouponList: [
        {label: 'Nidin優惠券', value: 1, code: '1231231dz'},
        {label: '柴犬優惠券', value: 2, code: '324efxde'},
        {label: '你好優惠券', value: 3, code: '654trrgxx'}
      ],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },
      /*
      addStoresExceptionSetting: {
        class: 'add-ex-store',
        options: [],
        choose: []
      },
      */
      deadType: [
        {label: '固定起迄時間', value: 'all_fixed'},
        {label: '固定結束時間', value: 'day_fixed'},
        {label: '發送日幾天後', value: 'day_day'}
      ],
      discountType: [
        {label: '折扣金額', value: 1}
        // {label: '折數', value: 2}
      ],
      couponSetting: [
        {label: '依訂單購買商品數設定', value: 'SC00001'},
        {label: '依個人訂單消費特定商品數', value: 'SC00002'},
        {label: '依個人訂單購買金額', value: 'SC00003'}
      ],
      useType: [
        {label: '品牌型', value: 2},
        {label: '門市型', value: 3}
      ],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      giftList: [
        {label: '依店家訂單消費金額滿額送', value: 1},
        {label: '依店家訂單商品個數滿額送', value: 2},
        {label: '依店家訂單消費指定商品數量滿額送', value: 3}
      ],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      couponList: [
        {
          coupon_info: { set_name: '', set_description: '', name: '', description: '', remark: '', discount_type: '', discountType: {label: '折扣金額', value: 1}, discount_value: '', priceType: {label: '免稅', value: 1}, price_type: '' },
          usage_store_config: { isFollowStore: true, usageStoreType: { label: '品牌型', value: 2 }, usage_store_type: '', usageStoreValue: '', usage_store_value: '', usage_method: 'manual', manual_store_ids: [] },
          time_config: { timeType: { label: '固定起迄時間', value: 'all_fixed' }, time_type: '', startTime: { time: '' }, endTime: { time: '' }, start_time: '', end_time: '', use_start_day: '', use_tolerance_day: '' },
          is_group_usage: 1,
          isGroupUsage: true,
          amount_unit: 1,
          coupon_strategy: {
            ruleCode: {label: '依訂單購買商品數設定', value: 'SC00001'},
            rule_code: '',
            name: '',
            description: '',
            limit: {
              min_amount: 1,
              min_money: '',
              order_method: '',
              orderMethod: '',
              order_types: [],
              orderTypes: [],
              delivery_types: [],
              deliveryTypes: []
            },
            setting: {
              one_max_amount: null,
              ratio: 1,
              lowest_unit_price: 0,
              money_unit: ''
            },
            store_exception_items: [
              {
                products: [],
                store_ids: []
              }
            ]
          }
        }
      ],
      activity: {
        status: 0,
        rule_code: 'SA00001',
        owner_type: {label: '品牌', value: 2},
        name: '',
        description: '',
        title: '',
        content: '',
        remark: '',
        sort: 1,
        start_time: '',
        end_time: '',
        aTime: {
          start: { time: '' },
          end: { time: '' }
        },
        store_ids: [],
        strategy_data: {
          ruleCode: 'SA00001',
          rule_code: 'SA00001',
          limit: {
            order_type: [],
            order_method: [],
            delivery_type: [],
            pay_place_type: [],
            min_total_paid_money: '',
            min_total_money: '',
            min_total_amount: '',
            min_paid_money: '',
            min_money: '',
            min_amount: '',
            min_sub_order_amount: ''
          },
          setting: {
            money_unit: '',
            max_count: '',
            vendorCustomProductList: [],
            vendor_custom_product_list: [],
            vendorList: [],
            amount_unit: 1
          },
          store_exception_items: [{
            products: [],
            productList: [],
            store_ids: []
          }]
        }
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: moment().format('YYYY-MM-DD HH:mm'),
      // new
      ownerTypeOptions: [
        {label: '品牌', value: 2},
        {label: '門市', value: 3},
        {label: '平台', value: 1}
      ],
      giveCoupons: {
        coupon_strategy: {},
        coupon_set_list: []
      },
      curId: 0,
      reNew: 0,
      reSet: 0,
      aStoreList: [],
      aStoreOption: [],
      brandSelect: {
        label: '',
        value: ''
      },
      brandSelectMuti: [],
      tradeType: [],
      tradeTypePlace: [
        {label: '線上結帳', value: 10},
        {label: 'POS店家結帳', value: 50}
      ],
      setInfoTimes: 0
    }
  },
  created () {
    if (this.$route.query.rule_code) {
      this.activity.strategy_data.ruleCode = this.$route.query.rule_code
      this.activity.strategy_data.rule_code = this.$route.query.rule_code
      this.activity.rule_code = this.$route.query.rule_code
    } else if (this.info.info.rule_code) {
      this.activity.strategy_data.ruleCode = this.info.info.rule_code
      this.activity.strategy_data.rule_code = this.info.info.rule_code
      this.activity.rule_code = this.info.info.rule_code
    }
    if (this.$route.name.indexOf('up') === -1) this.getBrandBrief()
    this.getTradeTypeList()
    // owner_type 和 owner_id 設定
    if (this.getRoleType === 30) this.activity.owner_type = {label: '品牌', value: 2}
    else if (this.getRoleType === 10) {
      this.activity.owner_type = {label: '門市', value: 3}
    }
  },
  methods: {
    ...mapActions(['setMenuStartTime', 'setMenuEndTime']),
    trigger (event) {
      if (event === 'delActivity') this.delActivity()
    },
    delActivity () {
      var self = this
      var url = '/activity/' + this.$route.params.activity_id + '/orderCouponComplete'
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/upCouponTable')
        }
      })
    },
    addChooseTag (newTag) {
      const tag = {
        name: newTag,
        id: ''
      }
      this.productChoseBrief.push(tag)
      this.activity.setting.vendorCustomProductList.push(tag)
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getStoreBrief (brandId, last) {
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            self.addStoresSetting.options.push(obj)
          }
          if (self.info.info.activity_id && self.setInfoTimes && last) self.setStore()
          else if (self.getRoleType === 10) {
            self.addStoresSetting.choose.push(self.addStoresSetting.options[0].value)
          }
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          // console.log(bList)
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
          }
          if (self.$route.name.indexOf('up') > -1 && !self.setInfoTimes && self.info.info) {
            // console.log('getBrandBrief')
            self.setInfo()
          } else if (self.getRoleType === 10 || self.getRoleType === 30) {
            self.brandSelect = self.brandBrief[0]
            // console.log(self.brandSelect.value)
            self.getStore()
            // self.getStoreBrief(self.brandSelect.value, true)
          }
        }
      })
    },
    getTradeTypeList () {
      var self = this
      var url = '/platform/tradeTypeList'
      this.getData('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.tradeInfo = []
          var list = response.data.list
          for (var i = 0; i < list.length; i++) {
            if (list[i].is_valid && list[i].is_enable) {
              var option = {
                label: list[i].name,
                value: parseInt(list[i].type, 10)
              }
              self.tradeType.push(option)
            }
          }
        }
      })
    },
    getMutiStore () {
      this.aStoreOption = []
      this.storeBrief = []
      this.addStoresSetting.options = []
      this.addStoresSetting.choose = []
      this.brandList = []
      const self = this
      this.brandSelectMuti.forEach(function (brand, index) {
        if (index + 1 === self.brandSelectMuti.length) self.getStoreBrief(brand.value, true)
        else self.getStoreBrief(brand.value)
        self.brandList.push(brand)
      })
    },
    getStore () {
      this.aStoreOption = []
      this.storeBrief = []
      this.addStoresSetting.options = []
      this.addStoresSetting.choose = []
      this.brandList = []
      if (this.brandSelect.value) this.getStoreBrief(this.brandSelect.value, true)
      this.brandList.push(this.brandSelect)
    },
    checkActivity (tab, index) {
      var a = this.activity
      var sD = a.strategy_data // 活動策略
      var aD = this.giveCoupons.coupon_strategy // 優惠券策略
      var cD = this.giveCoupons.coupon_set_list // 優惠券
      let self = this
      var msg = ''
      if (this.cMethod === 1) {
        if (!a.title) msg = '活動名稱(前台)未填'
        else if (!a.name) msg = '活動名稱(後台)未填'
        else if (!a.sort) msg = '活動排序未填'
        else if (!a.content) msg = '活動說明(前台)未填'
        else if (this.checkNumber(a.sort))msg = '活動排序非數字'
        else if (!a.aTime.start.time) msg = '活動開始時間未填'
        else if (!moment(a.aTime.start.time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = '活動開始時間格式錯誤'
        else if (!a.aTime.end.time) msg = '活動結束時間未填'
        else if (!moment(a.aTime.end.time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = '活動結束時間格式錯誤'
        else if (!this.addStoresSetting.choose.length) msg = '參與活動店家未選'
        else if (this.addStoresSetting.choose.length > 1 && a.owner_type.value === 3) msg = '參與活動店家應只能選擇一家'
        else if (!sD.ruleCode) msg = '贈送規則未選'
      } else if (this.cMethod === 2) {
        if (sD.ruleCode === 'SA00001') {
          if (!sD.setting.money_unit) msg = '贈送條件達成金額未填'
          else if (this.checkNumber(sD.setting.money_unit)) msg = '贈送條件達成金額非數字'
        } else if (sD.ruleCode === 'SA00002') {
          if (sD.setting.amount_unit === '') msg = '贈送條件達成商品數未填'
          else if (this.checkNumber(sD.setting.amount_unit)) msg = '贈送條件達成商品數非數字'
          // else if (!sD.setting.lowest_unit_price) msg = '商品限制最低單價未填'
          else if (sD.setting.lowest_unit_price && this.checkNumber(sD.setting.lowest_unit_price)) msg = '商品限制最低單價非數字'
        } else if (sD.ruleCode === 'SA00003') {
          if (sD.setting.amount_unit === '') msg = '贈送條件達成商品數未填'
          else if (this.checkNumber(sD.setting.amount_unit)) msg = '贈送條件達成商品數非數字'
          else if (!sD.setting.vendor_custom_product_list.length) msg = '請選擇參與店家菜單並新增指定商品'
        }
      } else if (this.cMethod === 3) {
        if (aD.rule_code === 'SC00002') {
          if (!aD.setting.vendor_custom_product_list.length) msg = '請選擇參與店家菜單並新增指定商品'
        } else if (aD.rule_code === 'SC00003') {
          if (!aD.setting.money_unit) msg = '滿足商品金額未填'
          else if (this.checkNumber(aD.setting.money_unit)) msg = '滿足商品金額非數字'
        }
        // 共同
        if (!aD.rule_code) msg = '優惠券折抵規則未選'
        else if (!aD.name) msg = '折抵策略名稱未填'
        else if (!aD.description) msg = '折抵描述未填'
        else if (!aD.limit.min_amount) msg = '限制主單(或團長)最低購買數未填'
      } else if (this.cMethod === 4) {
        if (!cD.length) msg = '請新增優惠券'
        else {
          cD.forEach(function (coupon, index) {
            msg = self.checkCoupon(coupon, index)
          })
        }
      }
      this.getToast(msg, tab, index)
    },
    getToast (msg, tab, index) {
      if (tab && this.cMethod > index) {
        // 往前步驟
        this.cMethod = index
      } else if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (tab) {
        this.cMethod = index
      } else if (this.cMethod !== 4) {
        this.cMethod++
      } else {
        this.setData()
      }
      /*
      // 測試
      if (tab) this.cMethod = index
      else this.setData()
      */
    },
    checkCoupon (coupon, index) {
      const c = coupon
      const cInfo = coupon.coupon_info
      const usConfig = coupon.usage_store_config
      const tConfig = coupon.time_config
      let msg = ''
      if (!cInfo.name) msg = '第' + index + '張優惠券名稱(前台)未填'
      else if (!cInfo.set_name) msg = cInfo.name + '的優惠券名稱(後台)未填'
      else if (!cInfo.description) msg = cInfo.name + '的優惠券說明(前台)未填'
      else if (!cInfo.set_description) msg = cInfo.name + '的優惠券說明(後台)未填'
      else if (!cInfo.remark) msg = cInfo.name + '的優惠券備註未填'
      else if (!cInfo.discount_value) msg = cInfo.name + '的優惠券折扣金額未填'
      else if (this.checkNumber(cInfo.discount_value)) msg = cInfo.name + '的優惠券折扣金額非數字'
      else if (!c.amount_unit) msg = cInfo.name + '的一次發送張數未填'
      else if (this.checkNumber(c.amount_unit)) msg = cInfo.name + '的一次發送張數非數字'
      else if (!cInfo.price_type.value) msg = cInfo.name + '的優惠券稅制未選'
      else if (!usConfig.usage_store_type.value) msg = cInfo.name + '的優惠券類型未選'
      else if (!usConfig.usage_method.value) msg = cInfo.name + '的優惠券類型未選'
      else if (usConfig.usage_store_type.value === 2 && !usConfig.usage_store_value) msg = cInfo.name + '的適用對象未填'
      else if (usConfig.usage_method.value === 'manual' && !usConfig.usage_store_value) msg = cInfo.name + '的適用對象未填'
      else if (!tConfig.time_type.value) msg = cInfo.name + '的適用門市方式未選'
      // all_fixed
      else if (tConfig.time_type.value === 'all_fixed' && !tConfig.start_time) msg = cInfo.name + '的開始時間未填'
      else if (tConfig.time_type.value === 'all_fixed' && !moment(tConfig.start_time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = cInfo.name + '的開始時間格式錯誤'
      else if (tConfig.time_type.value === 'all_fixed' && !tConfig.end_time) msg = cInfo.name + '的結束時間未填'
      else if (tConfig.time_type.value === 'all_fixed' && !moment(tConfig.end_time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = cInfo.name + '的結束時間格式錯誤'
      // day_fixed
      else if (tConfig.time_type.value === 'day_fixed' && !tConfig.use_start_day && tConfig.use_start_day !== 0) msg = cInfo.name + '的拿到優惠券後幾天開始未填'
      else if (tConfig.time_type.value === 'day_fixed' && this.checkNumber(tConfig.use_start_day)) msg = cInfo.name + '的拿到優惠券後幾天開始非數字'
      else if (tConfig.time_type.value === 'day_fixed' && !tConfig.end_time) msg = cInfo.name + '的結束時間未填'
      else if (tConfig.time_type.value === 'day_fixed' && !moment(tConfig.end_time, 'YYYY-MM-DD HH:mm:ss').isValid()) msg = cInfo.name + '的結束時間格式錯誤'
      // day_day
      else if (tConfig.time_type.value === 'day_day' && !tConfig.use_start_day.length && tConfig.use_start_day !== 0) msg = cInfo.name + '的拿到優惠券後幾天開始未填'
      else if (tConfig.time_type.value === 'day_day' && this.checkNumber(tConfig.use_start_day)) msg = cInfo.name + '的拿到優惠券後幾天開始非數字'
      else if (tConfig.time_type.value === 'day_day' && !tConfig.use_tolerance_day) msg = cInfo.name + '的開始後幾天結束未填'
      else if (tConfig.time_type.value === 'day_day' && this.checkNumber(tConfig.use_tolerance_day)) msg = cInfo.name + '的開始後幾天結束非數字'
      else if (usConfig.usage_method.value === 'manual' && !usConfig.manual_store_ids.length) msg = cInfo.name + '的優惠券可用店家未新增'
      return msg
    },
    checkNumber (val) {
      if (isNaN(parseInt(val, 10))) return true
      else if (typeof parseInt(val, 10) !== 'number') return true
      return false
    },
    setData () {
      const self = this
      let data = {
        strategy_data: {},
        give_coupons: []
      }
      let s = {
        setting: {},
        limit: {}
      }
      let cS = {
        coupon_strategy: {
          setting: {},
          limit: {}
        },
        coupon_set_list: []
      }
      const a = this.activity
      const sD = a.strategy_data
      const gD = this.giveCoupons
      const cr = this.$route.name === 'crActivityInfoForm'
      const up = this.$route.name === 'upActivity'
      let ruleCode = 'SA00001'
      if (this.$route.query.rule_code) ruleCode = this.$route.query.rule_code
      else if (this.info.info.rule_code) ruleCode = this.info.info.rule_code
      if (this.cMethod === 1 || cr || up) {
        data.rule_code = ruleCode
        if (cr || (up && self.getRoleType === 99)) {
          // owner_type
          data.owner_type = a.owner_type.value
          // owner_id
          data.owner_id = 0
          if (data.owner_type === 1) data.owner_id = 0
          else if (data.owner_type === 2) data.owner_id = this.brandSelect.value
          else if (data.owner_type === 3) data.owner_id = this.addStoresSetting.choose[0]
        }
        data.name = a.name
        if (a.description) data.description = a.description
        data.title = a.title
        data.content = a.content
        if (a.remark) data.remark = a.remark
        data.sort = a.sort
        data.start_time = a.aTime.start.time
        data.end_time = a.aTime.end.time
        data.store_ids = this.addStoresSetting.choose
      }
      if (this.cMethod === 2 || cr || up) {
        let sLimit = s.limit
        let sDLimit = sD.limit
        let sSetting = s.setting
        let sDSetting = sD.setting
        // 共同
        if (sDLimit.delivery_type.length) {
          sLimit.delivery_type = []
          sDLimit.delivery_type.forEach(function (dType) {
            sLimit.delivery_type.push(self.deliveryType.find(function (o) { return o.value === dType.value }).value)
          })
        }
        if (sDLimit.order_type.length) {
          sLimit.order_type = []
          sDLimit.order_type.forEach(function (oType) {
            sLimit.order_type.push(self.orderType.find(function (o) { return o.value === oType.value }).value)
          })
        }
        if (sDLimit.pay_place_type.length) {
          sLimit.pay_place_type = []
          sDLimit.pay_place_type.forEach(function (tTypePlace) {
            sLimit.pay_place_type.push(self.tradeTypePlace.find(function (o) { return o.value === tTypePlace.value }).value)
          })
        }
        if (sDLimit.order_method.length) {
          sLimit.order_method = []
          sDLimit.order_method.forEach(function (oMethod) {
            sLimit.order_method.push(self.orderMethod.find(function (o) { return o.value === oMethod.value }).value)
          })
        }
        if (sDLimit.min_total_paid_money) sLimit.min_total_paid_money = sDLimit.min_total_paid_money
        if (sDLimit.min_total_money) sLimit.min_total_money = sDLimit.min_total_money
        if (sDLimit.min_total_amount) sLimit.min_total_amount = sDLimit.min_total_amount
        if (sDLimit.min_paid_money) sLimit.min_paid_money = sDLimit.min_paid_money
        if (sDLimit.min_money) sLimit.min_money = sDLimit.min_money
        if (sDLimit.min_amount) sLimit.min_amount = sDLimit.min_amount
        if (sDLimit.min_sub_order_amount) sLimit.min_sub_order_amount = sDLimit.min_sub_order_amount
        // console.log(data.rule_code)
        if (data.rule_code === 'SA00001') {
          sSetting.money_unit = sDSetting.money_unit
          // max_count
          if (sDSetting.max_count) sSetting.max_count = sDSetting.max_count
          else sSetting.max_count = null
          // store_exception_items
          s.store_exception_items = [
            { products: [], store_ids: [] }
          ]
          if (sD.store_exception_items[0].products.length) {
            sD.store_exception_items[0].products.forEach(function (exProd) {
              const prod = {
                vendor_custom_id: exProd.vendor_custom_id,
                name: exProd.product_name
              }
              s.store_exception_items[0].products.push(prod)
            })
            s.store_exception_items[0].store_ids = this.addStoresSetting.choose
          }
        } else if (data.rule_code === 'SA00002') {
          sSetting.amount_unit = sDSetting.amount_unit
          if (sDSetting.lowest_unit_price) sSetting.lowest_unit_price = sDSetting.lowest_unit_price
          else sSetting.lowest_unit_price = 0
          // max_count
          if (sDSetting.max_count) sSetting.max_count = sDSetting.max_count
          else sSetting.max_count = null
          // store_exception_items
          s.store_exception_items = [
            { products: [], store_ids: [] }
          ]
          if (sD.store_exception_items[0].products.length) {
            sD.store_exception_items[0].products.forEach(function (exProd) {
              const prod = {
                vendor_custom_id: exProd.vendor_custom_id,
                name: exProd.product_name
              }
              s.store_exception_items[0].products.push(prod)
            })
            s.store_exception_items[0].store_ids = this.addStoresSetting.choose
          }
        } else if (data.rule_code === 'SA00003') {
          sSetting.amount_unit = sDSetting.amount_unit
          // max_count
          if (sDSetting.max_count) sSetting.max_count = sDSetting.max_count
          else sSetting.max_count = null
          // vendor_custom_product_list
          sSetting.vendor_custom_product_list = []
          sDSetting.vendor_custom_product_list.forEach(function (vendorProd) {
            const vProd = {
              id: vendorProd.vendor_custom_id,
              name: vendorProd.product_name
            }
            sSetting.vendor_custom_product_list.push(vProd)
          })
          s.store_exception_items = []
        }
      }
      if (this.cMethod === 3 || cr || up) {
        cS.coupon_strategy.rule_code = gD.coupon_strategy.rule_code
        cS.coupon_strategy.name = gD.coupon_strategy.name
        cS.coupon_strategy.description = gD.coupon_strategy.description
        const cLimit = cS.coupon_strategy.limit
        const gCLimit = gD.coupon_strategy.limit
        const cSetting = cS.coupon_strategy.setting
        const gSetting = gD.coupon_strategy.setting
        // limit
        cLimit.min_amount = gCLimit.min_amount
        if (gCLimit.min_money) cLimit.min_money = gCLimit.min_money
        if (gCLimit.delivery_types.length) {
          cLimit.delivery_types = []
          gCLimit.delivery_types.forEach(function (dType) {
            cLimit.delivery_types.push(self.deliveryType.find(function (o) { return o.value === dType.value }).value)
          })
        }
        if (gCLimit.order_types.length) {
          cLimit.order_types = []
          gCLimit.order_types.forEach(function (oType) {
            cLimit.order_types.push(self.orderType.find(function (o) { return o.value === oType.value }).value)
          })
        }
        if (gCLimit.order_method) {
          cLimit.order_method = gCLimit.order_method.value
          // 如果是陣列形式
          /*
          gCLimit.order_method.forEach(function (oMethod) {
            cLimit.order_method.push(self.orderMethod.find(function (o) { return o.value === oMethod }))
          })
          */
        }
        // setting
        const cStrategy = cS.coupon_strategy
        if (cStrategy.rule_code === 'SC00001') {
          if (gSetting.one_max_amount) cSetting.one_max_amount = gSetting.one_max_amount
          else cSetting.one_max_amount = null
          cSetting.ratio = 1
          if (gSetting.lowest_unit_price) cSetting.lowest_unit_price = gSetting.lowest_unit_price
          else cSetting.lowest_unit_price = 0
          // store_exception_items
          cStrategy.store_exception_items = [
            { products: [], store_ids: [] }
          ]
          gD.coupon_strategy.store_exception_items[0].products.forEach(function (exProd) {
            const prod = {
              vendor_custom_id: exProd.vendor_custom_id,
              name: exProd.product_name
            }
            cStrategy.store_exception_items[0].products.push(prod)
          })
          // cStrategy.store_exception_items[0].store_ids = gD.coupon_strategy.store_exception_items[0].store_ids
          cStrategy.store_exception_items[0].store_ids = self.addStoresSetting.choose
        } else if (cStrategy.rule_code === 'SC00002') {
          if (gSetting.one_max_amount) cSetting.one_max_amount = gSetting.one_max_amount
          else cSetting.one_max_amount = null
          cSetting.ratio = 1
          // cSetting.vendor_custom_product_list = gSetting.vendor_custom_product_list
          // vendor_custom_product_list
          cSetting.vendor_custom_product_list = []
          gSetting.vendor_custom_product_list.forEach(function (vendorProd) {
            const vProd = {
              id: vendorProd.vendor_custom_id,
              name: vendorProd.product_name
            }
            cSetting.vendor_custom_product_list.push(vProd)
          })
          cStrategy.store_exception_items = []
        } else if (cStrategy.rule_code === 'SC00003') {
          if (gSetting.one_max_amount) cSetting.one_max_amount = gSetting.one_max_amount
          else cSetting.one_max_amount = null
          cSetting.ratio = 1
          cSetting.money_unit = gSetting.money_unit
          // store_exception_items
          cStrategy.store_exception_items = [
            { products: [], store_ids: [] }
          ]
          gD.coupon_strategy.store_exception_items[0].products.forEach(function (exProd) {
            const prod = {
              vendor_custom_id: exProd.vendor_custom_id,
              name: exProd.product_name
            }
            cStrategy.store_exception_items[0].products.push(prod)
          })
          cStrategy.store_exception_items[0].store_ids = gD.coupon_strategy.store_exception_items[0].store_ids
        }
      }
      if (this.cMethod === 4 || cr || up) {
        const cList = gD.coupon_set_list
        cList.forEach(function (c) {
          const cInfo = c.coupon_info
          const cConfig = c.usage_store_config
          const tConfig = c.time_config
          // console.log(c)
          const coupon = {
            coupon_info: {
              set_name: cInfo.set_name,
              set_description: cInfo.set_description,
              name: cInfo.name,
              description: cInfo.description,
              remark: cInfo.remark,
              discount_type: 1,
              discount_value: cInfo.discount_value,
              price_type: cInfo.price_type.value
            },
            usage_store_config: {
              usage_store_type: cConfig.usage_store_type.value,
              usage_method: cConfig.usage_method.value
            },
            time_config: {
              time_type: tConfig.time_type.value
            },
            is_group_usage: 1,
            amount_unit: c.amount_unit
          }
          // usage_store_value
          if (coupon.usage_store_config.usage_store_type === 1) coupon.usage_store_config.usage_store_value = null
          else if (coupon.usage_store_config.usage_store_type === 2) coupon.usage_store_config.usage_store_value = cConfig.usage_store_value.value
          else if (coupon.usage_store_config.usage_store_type === 3 && coupon.usage_store_config.usage_method === 'order_store') coupon.usage_store_config.usage_store_value = null
          else if (coupon.usage_store_config.usage_store_type === 3) coupon.usage_store_config.usage_store_value = cConfig.usage_store_value.value
          // manual
          if (coupon.usage_store_config.usage_method === 'manual') {
            if (coupon.usage_store_config.usage_store_type === 3) coupon.usage_store_config.manual_store_ids = [cConfig.usage_store_value.value]
            else coupon.usage_store_config.manual_store_ids = cConfig.manual_store_ids
          }
          // time_config
          if (coupon.time_config.time_type === 'all_fixed') {
            coupon.time_config.start_time = tConfig.start_time
            coupon.time_config.end_time = tConfig.end_time
          } else if (coupon.time_config.time_type === 'day_fixed') {
            coupon.time_config.use_start_day = tConfig.use_start_day
            coupon.time_config.end_time = tConfig.end_time
          } else if (coupon.time_config.time_type === 'day_day') {
            coupon.time_config.use_start_day = tConfig.use_start_day
            coupon.time_config.use_tolerance_day = tConfig.use_tolerance_day
          }
          cS.coupon_set_list.push(coupon)
        })
      }
      data.strategy_data = s
      data.give_coupons.push(cS)
      if (cr) this.crActivity(data)
      else this.upActivity(data)
    },
    setInfo () {
      const self = this
      // console.log('setInfo')
      const info = this.info.info
      const attend = this.info.attend_stores
      const strategy = this.info.strategy_data
      this.activity = {
        status: info.status,
        rule_code: info.rule_code,
        owner_type: this.ownerTypeOptions.find(function (option) { return option.value === info.owner_type }),
        name: info.name,
        description: info.description,
        title: info.title,
        content: info.content,
        remark: info.remark,
        sort: info.sort,
        start_time: info.start_time,
        end_time: info.end_time,
        aTime: {
          start: { time: info.start_time },
          end: { time: info.end_time }
        },
        store_ids: [],
        strategy_data: {
          ruleCode: info.rule_code,
          rule_code: info.rule_code,
          limit: {
            order_type: [], // 查
            order_method: [], // 查
            delivery_type: [], // 查
            pay_place_type: [], // 查
            min_total_paid_money: strategy.limit.min_total_paid_money,
            min_total_money: strategy.limit.min_total_money,
            min_total_amount: strategy.limit.min_total_amount,
            min_paid_money: strategy.limit.min_paid_money,
            min_money: strategy.limit.min_money,
            min_amount: strategy.limit.min_amount,
            min_sub_order_amount: strategy.limit.min_sub_order_amount
          },
          setting: {
            money_unit: strategy.setting.money_unit,
            max_count: strategy.setting.max_count,
            vendorCustomProductList: [], // 查
            vendor_custom_product_list: [],  // 查
            vendorList: [], // 查
            amount_unit: 1,
            lowest_unit_price: ''
          },
          store_exception_items: [{
            products: [],
            productList: [],
            store_ids: []
          }]
        }
      }
      // 參與品牌需判斷擁有者 brandSelectMuti brandSelect
      if (info.owner_type === 1) {
        attend.forEach(function (brand) {
          const bId = brand.brand_id
          // console.log(brand.brand_id)
          const brandOption = self.brandBrief.find(function (brand) { return bId === brand.value })
          self.brandSelectMuti.push(brandOption)
        })
        self.getMutiStore()
      } else if (info.owner_type === 2) {
        this.brandSelect = this.brandBrief.find(function (brand) { return info.owner_id === brand.value })
        self.getStore()
      } else if (info.owner_type === 3) {
        self.brandSelect = self.brandBrief.find(function (brand) { return attend[0].brand_id === brand.value })
        // 設定參與店家
        self.getStore()
      }
      // lowesr_unit_price
      if (strategy.setting.lowest_unit_price) this.activity.strategy_data.setting.lowest_unit_price = strategy.setting.lowest_unit_price
      // amount_unit 變成 amount
      if (strategy.setting.amount) this.activity.strategy_data.setting.amount_unit = strategy.setting.amount
      else if (strategy.setting.amount_unit) this.activity.strategy_data.setting.amount_unit = strategy.setting.amount_unit
      // 設定info次數
      this.setInfoTimes++
      // console.log('time', this.setInfoTimes)
    },
    setStore () {
      var self = this
      let brands = this.info.attend_stores
      if (brands.length) {
        brands.forEach(function (brand) {
          brand.store_list.forEach(function (store) {
            self.addStoresSetting.choose.push(store.store_id)
          })
        })
      }
    },
    crActivity (data) {
      var self = this
      var url = '/activity/orderCouponComplete'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/upCouponTable')
        }
      })
    },
    upActivity (data) {
      var self = this
      var url = '/activity/' + this.$route.params.activity_id + '/orderCouponComplete'
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/upCouponTable')
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  },
  watch: {
    'activity.aTime.start.time' () {
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.activity.aTime.start.time).subtract(1, 'days')
        }
      ]
    },
    /*
    'activity.aTime.start' () {
      this.endLimit = [
        {
          type: 'fromto',
          from: this.activity.aTime.start
        }
      ]
      this.setMenuStartTime(this.activity.aTime.start)
    },
    'activity.aTime.end' () {
      this.startLimit = [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss'),
          to: this.activity.aTime.end
        }
      ]
      this.setMenuEndTime(this.activity.aTime.end)
    },
    */
    'content.bindingBrandList' () {
      var self = this
      this.storeBrief = []
      this.content.bindingStoreList = []
      this.content.bindingBrandList.forEach(function (array) {
        const brandId = array.value
        self.getStoreBrief(brandId)
      })
    },
    'addStoresSetting.choose' () {
      this.activity.store_ids = this.addStoresSetting.choose
      this.aStoreList = []
      const self = this
      if (this.addStoresSetting.choose.length) {
        this.addStoresSetting.choose.forEach(function (sId) {
          const store = self.addStoresSetting.options.find(function (obj) { return obj.value === sId })
          self.aStoreList.push(store)
        })
      }
    },
    'activity.title' () {
      if (this.$route.name.indexOf('cr') > -1) this.activity.name = this.activity.title
    },
    'activity.content' () {
      if (this.$route.name.indexOf('cr') > -1) this.activity.description = this.activity.content
    },
    'info.info' () {
      const self = this
      if (self.$route.name.indexOf('up') > -1 && !self.setInfoTimes && self.info.info.activity_id) self.getBrandBrief()
    }
  }
}
</script>
<style lang="sass">
.coupon-left
  float: left
  width: calc(100% / 3 * 2 + 15px)
  padding-right: 5px
.coupon-right
  float: left
  background: #3c8dbc
  width: calc(100% / 3 - 15px)
  position: absolute
  right: 0
  top: 0
  height: 100%
  border-left: 5px black dashed
  border-radius: 0px 6px 6px 0px
  color: white
  .v-middle
    position: absolute
    top: calc(50% - 28.5px)
    font-size: 40px
    text-align: center
    width: 100%
    left: 0
</style>
<style lang="sass" scoped>
// .ranges
  display: none
.coupon.form-left, .coupon.form-right
  width: 50%
  float: left
.coupon.form-right
  padding: 20px 20px 20px 10px
.coupon.form-left
  padding: 20px 10px 20px 20px
.coupon.form-left.w-100-p
  padding: 20px 20px
.min-item.active, .hour-item.active, .day.checked
  background: #222d32 !important
.w-200
  width: 180px !important
.m-b-15
  margin-bottom: 15px !important
.btn-all-store
  position: absolute
  right: 10px
  z-index: 30
  top: 0px
.input-white
  border: 0px
@media screen and (max-width: 767px)
  .p-sm-10-p
    padding-right: 10px !important
    padding-left: 10px !important
@media screen and (min-width: 768px)
  .p-sm-10-p
    padding-right: calc(20% - 15px) !important
    padding-left: calc(20% + 10px) !important
@media screen and (min-width: 991px)
  .p-sm-10-p
    padding-right: calc(10% - 10px) !important
    padding-left: 10% !important
</style>
<style lang="sass">
  .multiselect__content-wrapper, .multiselect__content-wrapper *
    z-index: 99
  .m-t-0
    margin-top: 0px
  .input-group .form-control
    z-index: auto !important
  textarea
    max-width: 100%
    min-widht: 100%
  .modal-title
    width: calc(100% - 20px)
  @media screen and (max-width: 767px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(100vw - 185px)
  @media screen and (min-width: 768px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(50vw - 190px)
  @media screen and (min-width: 991px)
    .input-group .cov-vue-date .cov-datepicker
      max-width: calc(30vw - 190px)
</style>



// WEBPACK FOOTER //
// ActivityForm.vue?b2bfb25a